<template>
  <div
    class="check-list__item"
    :class="{reversed}"
  >
    <div>
      <CheckIcon
        class="check-list__item__icon"
        :variant="variant"
        :size="16"
      />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import CheckIcon from './icons/Check.icon.vue'

export default defineNuxtComponent({
  components: {
    CheckIcon,
  },
  props: {
    reversed: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default' // default, acent, secondary
    },
  }
})
</script>

<style lang="scss" scoped>
.check-list__item {
  @apply flex items-center;

  @apply gap-1;
  @screen md {
    @apply gap-2;
  }

  &__icon {
    width: 20px;
  }
}
.reversed {
  @apply flex-row-reverse;
}
</style>
